import React from 'react';

function DataDisplay({ responseMessage, isErrorResponseMessage, noDataInfoMessage }) {
  return (
    <div className="response-container" style={{ marginTop: '20px' }}>
      {responseMessage && (
        <p className={isErrorResponseMessage ? 'error-message' : 'success-message'}>
          {responseMessage}
        </p>
      )}
      {noDataInfoMessage && <p className="info-message">{noDataInfoMessage}</p>}
    </div>
  );
}

export default DataDisplay;